export default "__VITE_ASSET__2949325a__"